module.exports = __webpack_public_path__ + "img/404-not-found.af3d3c13.jpg";